export const newsDataSource = {
  product: [
    {
      title: '5.2 Hall H -C111 Excelfore is waiting for you at the Expo',
      href: '10001',
      date: '2023-11-8',
      cover: 'https://excelfore.com/hs-fs/hubfs/ExcelforeLogo-RedBlueForLightBackground.png?width=381&height=80&name=ExcelforeLogo-RedBlueForLightBackground.png'
    },
    {
      title: 'FAW HongQi E001 project SOME/IP protocol stack technology',
      href: '20002',
      date: '2024-1-19',
      cover: 'https://excelfore.com/hs-fs/hubfs/ExcelforeLogo-RedBlueForLightBackground.png?width=381&height=80&name=ExcelforeLogo-RedBlueForLightBackground.png'
    },
  ],
  company: [
    {
      title: 'Excelfore Technology Information Co., Ltd. Beijing auto show participation report',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/pErHS9vufvT-8-bioV1QCA',
      date: '2024-05-22',
      cover: require('@/assets/article/article-03.jpg')
    },
    {
      title: 'Excelfore invites you to visit the 2024 Beijing International Auto Show',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/EbfNaAk8T_QPA09q37aiBQ',
      date: '2024-04-23',
      cover: require('@/assets/article/article-02.png')
    },
    {
      title: 'Thank you to Excelfore - Annual Outstanding Employee Recognition and 2024-Annual Meeting',
      type: 'weChart',
      href: 'https://mp.weixin.qq.com/s/D8fg8zq-B4wjcj2b1JuuTA',
      date: '2024-02-02',
      cover: require('@/assets/article/article-01.png')
    },
    {
      title: 'The original heart does not change, all the way forward, Excelfore China was officially established',
      href: '20001',
      date: '2017-06-28',
      cover: 'https://excelfore.com/hs-fs/hubfs/ExcelforeLogo-RedBlueForLightBackground.png?width=381&height=80&name=ExcelforeLogo-RedBlueForLightBackground.png'
    },
  ],
  profession: [
    {
      title: 'The new energy automobile industry reshuffle is imminent, 2023- Who is the master?',
      href: '30001',
      date: '2023-1-3',
      cover: 'https://static.neituixiaowangzi.com/company/2017/11-14/213637433843162256.jpg'
    },
  ]
};
